import api from "../api";

export const getTribes = async () => {
  return api.getApi().get(api.getBaseUrl() + "tribes");
};

export const getTribe = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `tribes/${id}`);
};

export const createTribe = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "tribes", data);
};

export const joinTribe = async (id) => {
  return api.getApi().post(api.getBaseUrl() + `tribes/${id}/join`, {});
};

export const leaveTribe = async (id) => {
  return api.getApi().post(api.getBaseUrl() + `tribes/${id}/leave`, {});
};

export const sendTribeMessage = async (id, content) => {
  return api.getApi().post(api.getBaseUrl() + `tribes/${id}/messages`, { content });
};
